import {
  OneTrust,
  ProjectRootProvider,
  getTranslations,
  resolveBestLanguage
} from "@onelogin/react-components";
import { Provider, connect } from "react-redux";
import React, { useEffect, useState } from "react";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch
} from "react-router-dom";
import { createIntl, createIntlCache } from "react-intl";

import AppContent from "./AppContent";
import ErrorBoundary from "./ErrorBoundary";
import { PUBLIC_URL } from "../constants/Env";
import { RawIntlProvider } from "react-intl";
import { ThemeProvider } from "styled-components";
import { getLanguage } from "../translations/translations";

const cache = createIntlCache();

const App = ({ store, theme, user }) => {
  const initialIntl = createIntl(
    {
      locale: "en",
      messages: {}
    },
    cache
  );
  const [intl, setIntl] = useState(initialIntl);

  useEffect(() => {
    if (user.currentLanguageLocale) {
      const { languageTag, primaryLanguageTag } = resolveBestLanguage({
        userLanguage: user.currentLanguageLocale
      });
      const messages = {
        ...getTranslations(languageTag),
        ...getLanguage(languageTag)
      };
      const newIntl = createIntl(
        {
          locale: primaryLanguageTag,
          messages
        },
        cache
      );
      setIntl(newIntl);
    }
  }, [user]);

  return (
    <ErrorBoundary>
      <OneTrust
        cookieManagementEnabled={user?.company?.cookieManagementEnabled}
      >
        <ProjectRootProvider value="notes2">
          <ThemeProvider theme={theme}>
            <RawIntlProvider value={intl}>
              <Provider store={store}>
                <Router>
                  <Switch>
                    <Route path={`${PUBLIC_URL}`} component={AppContent} />
                    <Redirect path="*" to={`${PUBLIC_URL}`} />
                  </Switch>
                </Router>
              </Provider>
            </RawIntlProvider>
          </ThemeProvider>
        </ProjectRootProvider>
      </OneTrust>
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  theme: state.branding,
  user: state.user
});
export default connect(mapStateToProps)(App);
